<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
html,
body,
#app {
  margin: 0;
  padding: 0;
  width: 100%;
  height: 100%;
  overflow: hidden;
}

body {
  background: #04122d;
  font-family: 'Microsoft YaHei', 'PingFang SC', sans-serif;
}

* {
  box-sizing: border-box;
}
</style>
